import './App.css';
import React, {useEffect, useRef, useState} from 'react';
import { Flex, Input, Layout, Tour, Typography, Button, Menu, ConfigProvider, Modal, Form, Result, Space, Tag, message } from 'antd';
import Icon  from '@ant-design/icons';
import { ConsumablePartsComponent } from './components/ConsumablePartsComponent';
import { RotablePartsComponent } from './components/RotablePartsComponent';
import { FilterComponent } from './components/FilterComponent';
import { CopyOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from "react-redux";
import { setPartType } from './redux/partsSlice';
import { setSearchText as consumeText}  from './redux/consumeSlice';
import { setSearchText as rotableText } from './redux/rotableSlice';
import { MailOutlined, QuestionOutlined } from '@ant-design/icons';
import { sendMail } from './redux/mailThunk';

function App() {
  const { Search } = Input;
  const selectParts = useSelector(state => state.partTypeState.partType);
  const selectedConFleet = useSelector(state => state.consumeState.selectedFleet);
  const selectedRotFleet = useSelector(state => state.rotableState.selectedFleet);
  const selectedConGroup = useSelector(state => state.consumeState.selectedGroup);
  const selectedRotGroup = useSelector(state => state.rotableState.selectedGroup);
  const { Header, Sider, Content } = Layout;
  const dispatch = useDispatch();
  const [current,setCurrent] = useState(selectParts);
  const [currentFleet, setCurrentFleet] = useState([]);
  const [currentGroup, setCurrentGroup] = useState([]);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const [open, setOpen] = useState(false);
  const [openContact,setOpenContact] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const { Text, Paragraph } = Typography;
  const { TextArea } = Input;
  const [messageApi, contextHolder] = message.useMessage();

  const gradientBackground = {    
      flex: 1,      
      backgroundImage: `url('GradientBG.png')`,
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover'
    } ;  
  

  const BulletSvg = () => (
    <svg width="20" height="20" viewBox='0 0 18 18' fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.17733 8.61036C-0.519542 8.26229 4.18324 5.30107 4.00884 4.77885C3.83445 4.25662 7.14372 8.61036 7.84035 8.61036C8.53699 8.61036 3.48604 12.2681 4.00884 12.4419C4.53164 12.6157 0.874203 8.95842 0.17733 8.61036Z" fill="#3F075C"/>
      <path d="M4.74813 4.03956C4.05126 3.69149 8.75404 0.730268 8.57964 0.208046C8.40525 -0.314177 11.7145 4.03956 12.4112 4.03956C13.1078 4.03956 8.05684 7.69726 8.57964 7.87107C9.10244 8.04488 5.445 4.38762 4.74813 4.03956Z" fill="#3F075C"/>
      <path d="M4.62899 13.0623C3.93212 12.7142 8.6349 9.75297 8.4605 9.23075C8.28611 8.70853 11.5954 13.0623 12.292 13.0623C12.9887 13.0623 7.9377 16.72 8.4605 16.8938C8.9833 17.0676 5.32586 13.4103 4.62899 13.0623Z" fill="#3F075C"/>
      <path d="M9.20004 8.49146C8.50316 8.1434 13.2059 5.18217 13.0315 4.65995C12.8572 4.13773 16.1664 8.49146 16.8631 8.49146C17.5597 8.49146 12.5087 12.1492 13.0315 12.323C13.5543 12.4968 9.89691 8.83953 9.20004 8.49146Z" fill="#3F075C"/>
    </svg>
  );

  const BulletIcon = (props) => <Icon component={BulletSvg} {...props} />

  const steps = [
    {
      title: 'Select parts type',
      description: 'Choose parts type of your interest.',
      target: () => ref1.current,      
      placement: 'bottom',
      type: 'primary'
    },
    {
      title: 'Filter result',
      description: 'Scope the search result to selected fleets and equipment groups',
      target: () => ref2.current,
      placement: 'right',
      type: 'primary'
    },    
    {
      title: 'Result will be shown here',
      description: 'All parts that meet filtered values will be shown here.',
      target: () => ref3.current,
      placement: 'top',
      type: 'primary'
    }
  ];

  const headerStyle = {
    height: 98,
    top: 0,
    zIndex: 999,
    position: 'sticky',
    paddingInline: 50,
    lineHeight: '98px',
    backgroundColor: '#fff',
    borderBottom: '3px solid #3F075C'
  };

  const siderStyle = {        
    //backgroundColor: '#F9FAFB',
    backgroundColor: 'transparent',
    maxHeight: '95vh',
    overflowY: 'auto',
    scrollbarWidth: 'none'
  };

  const contentStyle = { 
      width: 'auto',
      //backgroundColor: '#F9FAFB',
      backgroundColor: 'transparent',
      height: '100%',
      padding: 30,
      paddingTop: 40,      
    };
    
  const searchConsume = (value, _e, info) =>{
    const setSearchAction = consumeText(value);
    dispatch(setSearchAction);
  }

  const searchRotable = (value, _e, info) =>{
    const setSearchAction = rotableText(value);
    dispatch(setSearchAction);
  }

  const changeTag = (e) => {        
      setCurrent(e.key);     
      const setTagsAction =  setPartType(e.key);
      dispatch(setTagsAction);     
      console.log('Selected : '+ selectParts);
   }
   
  const items = [
    {
      label: 'Consumable',
      key: 'Consumable',
      icon: <BulletIcon style={{fontSize:24, display: selectParts==='Consumable'?'inline-block':'none'}}/>,
      style: {height:80, width:180, textAlign:'center', fontSize:18, fontWeight:(selectParts==='Consumable'?500:400)}
    },
    {
      label: 'Rotable',
      key: 'Rotable',
      width: 150,
      icon: <BulletIcon style={{fontSize:24, display: selectParts==='Rotable'?'inline-block':'none'}}/>,
      style: {height:80,  width:180, textAlign:'center', fontSize:18, fontWeight:(selectParts==='Rotable'?500:400)}
    }
  ]

  const submitToMail = (values) => {
    values.PartTypes = selectParts;
    values.Fleets = currentFleet;
    values.Groups = currentGroup;
    const mailAction = sendMail(values);        
    dispatch(mailAction).unwrap().then((resp)=> {           
      console.log(resp);
      if (resp.status===200){
        setOpenContact(false);      
        setModal2Open(true);  
      }
      else {
        messageApi.open({
          type: 'error',
          content: 'Your email cannot be sent!',
        });
      }
    });
  }

  const cancelMail = () => {
    setOpenContact(false);
  }

  const handleCloseModal2 = () => {
    setModal2Open(false);
  }

  useEffect(() => {
    if (selectParts!=undefined && selectParts!=""){
      if (selectParts==="Consumable"){        
        setCurrentFleet(selectedConFleet);                  
      }
      else if (selectParts==="Rotable") {
        setCurrentFleet(selectedRotFleet);      
      }
      else {
        setCurrentFleet([]);        
      }
    }   
  }, [selectedConFleet, selectedRotFleet]);


  useEffect(() => {
    if (selectParts!=undefined && selectParts!=""){
      if (selectParts==="Consumable"){
        setCurrentGroup(selectedConGroup);
      }
      else if (selectParts==="Rotable") {
        setCurrentGroup(selectedRotGroup);
      }
      else {
        setCurrentGroup([]);
      }
    }
  }, [selectedConGroup, selectedRotGroup]);


  const getApplicable = (applic) => {
    const tagItems = [];
    applic.map((val)=>{            
      tagItems.push(<Tag>{val}</Tag>)    
      }); 
    return (
     <>{tagItems}</>
    )      
  }

  const getGroup = (groups) => {
    const tagItems = [];
    groups.map((val) => {
      tagItems.push(<Tag>{val}</Tag>)    
    });
    return (
      <>{tagItems}</>
    )
  }

  return (
    <>
      {contextHolder}
      <ConfigProvider
          theme={{
            components: {              
              Modal:{
                titleColor: '#3F075C',
                titleFontSize: 24
              }       
            },
            token: {
              colorPrimary: '#52D97B'
            }
          }}
        >
        <Modal
            title={null}
            centered
            footer={null}
            open={modal2Open}
            onOk={handleCloseModal2}
            onCancel={handleCloseModal2}
            width={'40%'}
          >
            <Result
                status="success"
                title="Your email has been sent to THAI Airways."                                        
              />
        </Modal> 
        <Modal
            title="Contact Us"
            centered
            footer={null}
            open={openContact}
            onOk={()=> setOpenContact(false)}
            onCancel= {()=> setOpenContact(false)}            
            width={{
              xs: '90%',
              sm: '80%',
              md: '70%',
              lg: '60%',
              xl: '50%',
              xxl: '40%',
            }}
          >              
            <Flex vertical style={{width:'95%', justifyContent:'centerd',padding:10}}>
                <Paragraph style={{fontSize:16, color:'#515151'}}>
                  <img src="thaiLogo.png" width="60" height="18"/><br/>
                  <Flex style={{flex:1, justifyContent:'space-between'}}>
                    <Space><Text>To: </Text><Text>partsales@thaiairways.com</Text></Space>             
                  </Flex>                  
                </Paragraph>                                
                <Form name="MailForm" layout="vertical" requiredMark="optional" onFinish={submitToMail}>                  
                  <Paragraph style={{fontSize:14}}>
                  &nbsp;&nbsp;As you have announced the selling of aircraft spare parts on your website, we are interested in the following parts group:                    
                  </Paragraph>
                  <Paragraph>
                    <Space style={{marginLeft:20}}><Text>Parts Type: </Text><Tag>{selectParts}</Tag></Space>
                  </Paragraph>
                  <Paragraph>
                    <Space style={{marginLeft:20}}><Text>Equipment Group: </Text><Text>{getGroup(currentGroup)}</Text></Space>
                  </Paragraph>
                  <Paragraph style={{fontSize:14}}>With the proposed price(USD) at :</Paragraph>
                  <Form.Item name="Price" >                    
                    <Input size="middle" placeholder='9,999 USD'/>
                  </Form.Item>
                  <Form.Item label="Adddional Conditions" name="Message">
                    <TextArea rows={3}/>
                  </Form.Item>
                  <Paragraph style={{fontSize:14}}>
                  &nbsp;&nbsp;Please contact us at the following email:
                  </Paragraph>
                  <Form.Item name="Email" rules={[{required: true, message: 'Please enter your email'}]}>
                    <Input size="middle" placeholder='e.g. customer@exchange.com'/>
                  </Form.Item>                                  
                  <Form.Item name="Address" rules={[{required: true, message: 'Please enter your company name and address'}]}>
                    <TextArea row={2} placeholder='Company name and address'/>
                  </Form.Item>                                  
                  <Form.Item>
                    <Flex style={{width:'100%',justifyContent: 'space-between',gap:10}}>
                      <Button block size="large" type="primary" htmlType='submit'>Submit</Button>
                      <Button block size="large" type="default" onClick={cancelMail}>Cancel</Button>
                    </Flex>                  
                  </Form.Item>
                </Form>
              </Flex>
          </Modal>
    </ConfigProvider>
    <Layout>
      <Header style={headerStyle}>
        <Flex style={{flex:1,height:98,justifyContent:'space-between',alignItems:'center'}}>
            <a style={{alignItems:'center',verticalAlign:'middle',marginTop:30}} href={`${process.env.REACT_APP_PREFIX}/`}><img src="thaiLogo.png" width="140"/></a>
            <ConfigProvider
              theme={{
                components: {
                  Menu: {
                    activeBarHeight: 0,
                    activeBarWidth: 0,                  
                    itemSelectedColor: '#3F075C !important',
                    horizontalItemHoverBg: 'rgba(229,231,235,0.5)',
                    itemPaddingInline: 16                 
                  }
                },
              }}
            >   
            <Flex ref={ref1}>
              <Menu style={{marginTop:0,padding:0,height:90,width:500}} onClick={changeTag} selectedKeys={[current]} mode="horizontal" items={items}/>
            </Flex>            
            </ConfigProvider>
                 
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#3F075C',                
              },
            }}
          >       
          <Flex style={{gap:10}}>          
            <Button color="primary" size="large" variant="solid" icon={<MailOutlined style={{fontSize:18}}/>} iconPosition='end' onClick={()=>setOpenContact(true)}>Contact Us</Button>
            <Button type="default" size="large" shape="circle" icon={<QuestionOutlined/>} onClick={()=> {setOpen(true)}} />
          </Flex>
          </ConfigProvider>    
        </Flex>
      </Header>
      <Layout style={gradientBackground}>
        <Sider width='20%' style={siderStyle}>
          <Flex ref={ref2} style={{flex:1}}>
            <FilterComponent ref={ref2} />
          </Flex>
        </Sider>
        <Content ref={ref3} style={contentStyle}>
          {
            (current==="Consumable")?
            <ConsumablePartsComponent/>
            :
            <RotablePartsComponent/>
          }
        </Content>
      </Layout>
      <Tour open={open} onClose={() => setOpen(false)} steps={steps}></Tour>
    </Layout>   
  </> 
  );
}

export default App;
